import * as APIRoutes from '@mm/api-routes';
import AuthenticatedController from '@mm/state/controllers/AuthenticatedController';
import { ObjectUtils } from '@mm/utils';

const mockRes = {
  id: 0,
  name: '',
  created_at: '',
  page: {
    id: 0,
    name: '',
    notes: '',
    botId: 0,
    pageGroupId: 0,
    createdAt: '',
    updatedAt: '',
    kind: '',
    sortOrder: 0,
    searchToken: '',
    tokenLink: '',
    abandonedCount: 0,
    migrated: null,
    viewsCount: 0,
    sessionsStartedCount: 0,
    useCustomMenu: null,
  },
  authToken: '',
  companyId: 0,
  facebookPageId: 0,
  standaloneToken: '',
  userId: 0,
};

// service
export type AnonymousBot = typeof mockRes;

export class AnonymousBotController {
  static create(params: {
    source: string;
    facebookPageName?: string;
    companyId?: string;
  }): Promise<{
    success: boolean;
    errors: {};
    bot: AnonymousBot;
  }> {
    return AuthenticatedController.post(
      APIRoutes.STANDALONE_BOT,
      ObjectUtils.mapObjKeysToSnakeCase(params),
    );
  }

  static get(id: number): Promise<AnonymousBot> {
    return AuthenticatedController.get(`${APIRoutes.STANDALONE_BOT}/${id}`);
  }

  static connect(params: {
    standaloneToken: string | number;
    remotePageId: string;
    targetBotId?: number;
  }): Promise<{ success: boolean; bot: AnonymousBot; errors?: string[] }> {
    return AuthenticatedController.post(
      APIRoutes.STANDALONE_BOT_CONNECT_PAGE,
      params,
    );
  }
}
